import * as React from 'react'

import Head from '@/components/Head'
import { Flex } from '@chakra-ui/react'

const AuthLayout = ({ children, title }) => (
  <>
    <Head title={title} />
    <Flex h="100vh" bg="brand.900" justify="center" align="center">
      {children}
    </Flex>
  </>
)

export default AuthLayout
